"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupMISSING_CONTAINER_TO_SERVICE_ACCOUNT = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

var texts_1 = require("../texts");

function setupMISSING_CONTAINER_TO_SERVICE_ACCOUNT(builder) {
  builder.validator(validator_id_1.ValidatorID.MISSING_CONTAINER_TO_SERVICE_ACCOUNT).category(categories_1.ValidatorCategory.RBAC).title('Unresolved ServiceAccount reference in container').description("ServiceAccounts grant Kubernetes API permissions to workloads. \n\nThis validator detects when a ServiceAccount referred in a workload is not found.\n").affectedAllWorkloads().example("\nkind: Deployment\nspec:\n  template:\n    spec:\n      serviceAccountName: build-robot    # Service Account not found\n...\n").example("\napiVersion: v1\nkind: ServiceAccount\nmetadata:\n  name: robot                            # Different name\n").resolution(texts_1.RESOLUTION_TEXT.checkPresentInSameNamespace('ServiceAccount')).resolution(texts_1.RESOLUTION_TEXT.checkInDifferentNamespace('ServiceAccount', 'workload')).resolution(texts_1.RESOLUTION_TEXT.typoNameReference('ServiceAccount', 'workload')).externalLink('https://kubernetes.io/docs/tasks/configure-pod-container/configure-service-account/');
}

exports.setupMISSING_CONTAINER_TO_SERVICE_ACCOUNT = setupMISSING_CONTAINER_TO_SERVICE_ACCOUNT;